"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.coreInitiativesBulkDeleteAsyncSlice = void 0;
const name_1 = require("./name.js");
const get_1 = require("../get.js");
const xuder_1 = require("@sonar-software/xuder");
const _api_1 = require("../../../api/index.js");
const sonar_ts_types_1 = require("@sonar-software/sonar-ts-types");
exports.coreInitiativesBulkDeleteAsyncSlice = (0, xuder_1.createDeleteAsyncSlice)({
    httpSagaOptions: {
        successActionCreators: [
            () => get_1.coreInitiativesGetAsyncSlice.asyncActionCreators.repeatGetCoreInitiatives((previous) => (Object.assign(Object.assign({}, previous), { key: '', paginationDirection: sonar_ts_types_1.PaginationDirection.Forward })))
        ]
    },
    name: name_1.CoreInitiativesBulkName,
    receive: false,
    request: true,
    requestHandler: _api_1.deleteInitiativesBulk
});
//# sourceMappingURL=delete.js.map